var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.titre),expression:"titre"}],staticClass:"h2"},[_vm._v(_vm._s(_vm.titre))]),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.sousTitre),expression:"sousTitre"}],staticClass:"h3"},[_vm._v(_vm._s(_vm.sousTitre))])])
}
var staticRenderFns = []

export { render, staticRenderFns }